import useIsCompact from '@hooks/app/useIsCompact';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { default as LifeIdDesktop } from './life-id-desktop';
import LifeIdMobile from './life-id-mobile';

const LifeId: React.FunctionComponent<RouteComponentProps> = (props) => {
  const isCompact = useIsCompact();

  return isCompact ? <LifeIdMobile {...props} /> : <LifeIdDesktop {...props} />;
};

export default LifeId;
